module.exports = __webpack_public_path__ + "static/media/pdf.50c41bf3.png";